import { logWithPrefix } from "@/plugins/logging";
const log = logWithPrefix("[store/conflict.js]");

const getDefaultState = () => {
  return {
    hardware_verion: "",
    lan_ip: "",
  };
};

const state = getDefaultState();

const mutations = {
  SET_INFO(state, info) {
    state.hardware_verion = info.hardware_verion || "";
    state.lan_ip = info.lan_ip || "";
    log("@mu(SET_WARNING_MSG) state", state);
  },
};

const actions = {
  setInfo: ({ commit }, info) => {
    commit("SET_INFO", info);
    return info;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
